import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import useExcelDownloaderV2 from '../hooks/useExcelDownloaderV2';
import ExcelDownloadToast from './Toasters/ExcelDownloadToast';
//icons
import TrashIco from './icons/TrashIco'
import EditIco from './icons/EditIco'
import SkipNextIco from './icons/SkipNextIco'
import SkipPreviousIco from './icons/SkipPreviousIco'
import ArrowForward from './icons/ArrowForward'
import ArrowBack from './icons/ArrowBack'
import Spinner from './Spinner'
import InputForm from './InputForm';
import ComboBox from './ComboBox'
import { useAuth } from '../providers/AuthContext'
import { useAppContext } from '../providers/AppContext'
import { useNavigate } from 'react-router-dom'
import SpinnerText from './SpinnerText';

import DownloadIco from './icons/DownloadIco';
import Modal from './Modal';
import { translateDatePicker } from '../features/utils';

function Pagination({total, currentPage, maxPaginationPages, onChange}) {
  const totalPages = Math.ceil(total/maxPaginationPages);
  function getPagination(c, m, g) {
    console.log(c,m,g)
    // Si el número máximo de números a mostrar es mayor o igual al total de páginas, mostramos todas las páginas
    if (g >= m) {
      return Array.from({ length: m }, (_, i) => i + 1);
    }
    let start, end;
    // Si la página actual está en el principio
    if (c <= Math.floor(g / 2)) {
      start = 1;
      end = g;
    } 
    // Si la página actual está cerca del final
    else if (c + Math.floor(g / 2) >= m) {
      start = m - g + 1;
      end = m;
    } 
    // Si la página actual está en el medio
    else {
      start = c - Math.floor(g / 2);
      end = c + Math.floor(g / 2);
    }
    // Generamos el arreglo de números de página
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }
  let arrayPages = getPagination(currentPage,totalPages , maxPaginationPages)

  return (
    <div className='flex gap-1'>
      <button className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${ currentPage !== 1 ? "hover:bg-graysens": "cursor-not-allowed"}`} onClick={event => onChange(1)}>
        <SkipPreviousIco fill={currentPage !==1 ? "gray" : undefined}/>
      </button>
      <button className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${ currentPage !== 1 ? "hover:bg-graysens": "cursor-not-allowed"}`} onClick={event => onChange(currentPage-1 <= 1 ? 1: currentPage-1)}>
        <ArrowBack height='16px' width='16px' fill={currentPage !==1 ? "gray" : undefined}/>
      </button>
      {arrayPages.map((element,index)=> (
        <button key={index}
          className={`mx-0.5 rounded-md min-w-6 h-6 ${ element === currentPage ? 'bg-bluesens text-white' : 'bg-white hover:bg-graysens'  }`} value={element} onClick={event => onChange(event.target.value)}
        >
          {element}
        </button>
      ))}
      
      <button className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${ currentPage !== totalPages ? "hover:bg-graysens": "cursor-not-allowed"}`} onClick={event => onChange(currentPage+1 >= totalPages? totalPages: currentPage+1)}>
        <ArrowForward height='16px' width='16px' fill={currentPage !==totalPages ? "gray" : undefined}/>
      </button>
      <button className={`mx-0.5 rounded-md min-w-6 h-6 bg-white ${ currentPage !== totalPages ? "hover:bg-graysens": "cursor-not-allowed"}`} onClick={event => onChange(totalPages)}>
        <SkipNextIco fill={currentPage !==totalPages ? "gray" : undefined}/>
      </button>
    </div>
  )
}

function DictArrayValues({valueName,value}){
  const [showValueModal, setValueModal] = useState(false);
  const toggleModal = () =>{
    setValueModal(prev => !prev)
  }
  return (
    <>
    <Modal
        isOpen={showValueModal}
        onClose={() => {
          setValueModal(false);
        }}
        customType={2}
        colorTitle='bg-bluesens '
        title={valueName}
        
      >
       <div className="p-4 max-h-[70vh] overflow-y-auto bg-gray-100 rounded-lg">
      {/* ENCABEZADOS */}
      <div className="grid grid-cols-3 gap-4 font-semibold bg-gray-800 text-white p-3 rounded">
        <div>Key</div>
        <div>Value</div>
        <div>Units</div>
      </div>

      {/* CONTENIDO */}
      <div className="mt-1 space-y-2">
        {value.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 gap-2 bg-white p-2 rounded shadow-sm hover:bg-gray-50"
          >
            <div>{item.key}</div>
            <div>{item.value}</div>
            <div>{item.units || "-"}</div>
          </div>
        ))}
      </div>
    </div>
      </Modal>
      <span onClick={toggleModal} className='cursor-pointer text-bluesens font-semibold'>
        Ver
      </span>
    </>
    
  )
}
const GenericTable = forwardRef(({ actions = [], fetcher , externalId, download=false, downloadFunction = ()=>{}, tableSettings = [], multiTargetIds = []}, ref) => {
  const [search, setSearch] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [registers, setRegisters] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [total, setTotal] = useState(0);
  const [rowsNumber, setRowsNumber] = useState(10);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [dataRange, setDataRange] = useState('Hoy');
  const [selectedDateRange, setSelectedDateRange] =  useState({  
    activeTab: 'customDates',
    selectedRange: 'today',
    startDate: new Date(),
    endDate: new Date()
  })
  //fuentes adicionales
  const [selectedTargets, setSelectedTargets] = useState([]);

  const {auth} = useAuth();
  const {addToast} = useAppContext();
  const navigate = useNavigate();

  const [fetchingData, setFetchingData] = useState(true);
  const [downloading, setDownloading] = useState(false)

  const {
    downloadExcel,
    visible: excelVisible,
    progress: excelProgress,
    status: excelStatus,
    processedCount,
    totalCount,
    currentSheet
  } = useExcelDownloaderV2();
  
  const refreshTable = () => {
    console.log(multiTargetIds)
    async function fetchData(){
      //page = 1, limit = 5, searchTerm = "", sortBy = JSON.stringify({ column: "createdAt", isAscending: true })
      let parameters = await fetcher(
        auth?.token,
        externalId,
        currentPage,
        rowsNumber,
        search
      );
      if (externalId){
        parameters = await fetcher(
          auth?.token,
          externalId,
          currentPage,
          rowsNumber,
          search,
        );
      }
      else{
        parameters = await fetcher(
          auth?.token,
          currentPage,
          rowsNumber,
        );
      }
      return parameters;
    }
    try {
      setFetchingData(true);
      fetchData().then(response => {
        console.log(console.log(response));
        setRegisters(response.records);
        setHeaders(response.headers);
        setTotal(response.totalRecords);
        setFetchingData(false);
      }).catch(error => {
        if (!error.response){
          addToast("Error inesperado, intente nuevamente",2)
        }
        else if (error.response.status === 419){
          addToast("Sesión expirada",1)
          navigate('/logout')
        }
        else{
          addToast("Error en el servidor, intente nuevamente",2)
        }
      })
    } catch (error) {
      addToast("Error inesperado, intente nuevamente",2)
    }
  }
  const handleSearch = (searchValue) => {
    setSearch(searchValue)
    setCurrentPage(1)
  }
  const handleChangeDateRange = (value) => {
    setDataRange(translateDatePicker(value))
    setSelectedDateRange(value)
  }

  useImperativeHandle(ref, () => ({
    refreshTable,
    handleSearch,
    setSelectedDateRange,
    setDataRange
  }));
  
  const handlePagination = (selectedPage) => {
    setCurrentPage(Number(selectedPage));
  }

  const handleRowSelection = (event) => {
    setRowsNumber(Number(event.currentTarget.value));
    setCurrentPage(1);
  }

  //funcion 100% backend
  /* const handleDownloadExcel = async () => {
    try {
      setShowDownloadModal(false)
      setDownloading(true);
      addToast("Iniciando descarga, por favor espere",1);
      let response;
      if (externalId){
        response = await downloadFunction(
          auth?.token,
          externalId,
          currentPage,
          rowsNumber,
          {...search, selectedDateRange},
        );
      }
      else{
        response = await downloadFunction(
          auth?.token,
          currentPage,
          rowsNumber,
        );
      }
      setDownloading(false);
      addToast("Archivo descargado");
      console.log(response)
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      let filename = `registros_${new Date().toISOString().split('T')[0]}.xlsx`;
      const contentDisposition = response.headers['content-disposition'];
      console.log(contentDisposition)
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) filename = match[1];
      }
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      addToast("Error descargando Excel:" + String(error),2);
      console.error('Error descargando Excel:', error);
    }
  }; */

  //funcion nueva que funciona
  /* const handleDownloadExcel = async () => {
  setShowDownloadModal(false);

  await downloadExcel({
    filename: `registros_${new Date().toISOString().split('T')[0]}.xlsx`,
    tableSettings,

    fetchPage: async (page, limit) => {
      const response = await fetcher(
        auth?.token,
        externalId,
        page,
        limit,
        { ...search, selectedDateRange }
      );

      return {
        data: response.records,
        total: response.totalRecords
      };
    }
  });
}; */

  const handleDownloadExcel = async () => {
  setShowDownloadModal(false);

  // 🔥 evitar duplicados (MUY IMPORTANTE)
  const targets = [...new Set([externalId, ...selectedTargets])];
  await downloadExcel({
    filename: `registros_${new Date().toISOString().split('T')[0]}.xlsx`,
    tableSettings,

    // 🔥 pasar metadata para nombres de hojas
    multiTargetsMeta: multiTargetIds || [],

    targets,

    fetchPage: async (page, limit, targetId) => {
      const response = await fetcher(
        auth?.token,
        targetId || externalId, // 🔥 fallback seguro
        page,
        limit,
        { ...search, selectedDateRange }
      );

      return {
        data: response.records || [],
        total: response.totalRecords || 0,
      };
    }
  });
};

   useEffect( () => {
    refreshTable();
   }, [rowsNumber , currentPage , search]);

  return (
    <div className="overflow-x-auto mb-5">
      {/* Modal descarga de excel */}
      <ExcelDownloadToast
        visible={excelVisible}
        progress={excelProgress}
        status={excelStatus}
        processedCount = {processedCount}
        totalCount = {totalCount}
        currentSheet = {currentSheet}
      />
      <Modal
        isOpen={showDownloadModal}
        onClose={() => {
          setShowDownloadModal(false);
        }}
        customType={2}
        colorTitle='bg-bluesens '
        title={"Exportar a Excel"}
        
      >
        <p className="mb-4">
          Seleccione la fecha de exportación
        </p>
        {/* Filtro de rango */} 
        <div className="flex flex-col flex-1 gap-2 h-[20rem]"> 
          <InputForm 
            type="datarange" 
            text="Filtro de fecha" 
            value={dataRange} 
            AppendClassName="text-left" 
            onChange={event => handleChangeDateRange(event)} 
            dateRangeOptions={selectedDateRange} 
          /> 
          {/* Multihoja */}
        {multiTargetIds?.length > 0 && (
          <div className="mt-4">
            <span className="text-sm font-semibold text-gray-600">
              Seleccionar fuentes adicionales
            </span>

            <div className="mt-2 max-h-40 overflow-y-auto border rounded p-2">
              {multiTargetIds.filter(item => item.hasSubItems).map((item) => (
                <label key={item.id} className="flex items-center gap-2 py-1 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selectedTargets.includes(item.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedTargets(prev => [...prev, item.id]);
                      } else {
                        setSelectedTargets(prev =>
                          prev.filter(id => id !== item.id)
                        );
                      }
                    }}
                  />
                  <span>{item.label}</span>
                </label>
              ))}
            </div>
          </div>
        )}
        </div>

        
        <div className="flex justify-end">
          <button
            className="bg-bluesens text-white font-bold py-2 px-4 rounded mr-2"
            onClick={() => handleDownloadExcel()}
            disabled={downloading}
          >
            {downloading ? "Descargando...": "Descargar"}
          </button>
          <button
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
            onClick={() => setShowDownloadModal(false)}
          >
            Cancelar
          </button>
        </div>
      </Modal>
      {download  && !downloading &&(
        <div className='w-full flex justify-end'>
          <button className='flex gap-1 items-center' onClick={(event) => setShowDownloadModal(true)}> 
            <span className='text-gray-600'>Descargar excel</span>
            <DownloadIco fill='bluesens'/>
          </button>
        </div>
        
      )}
      {download && downloading && (
        <div className='w-full flex justify-end '>
          <div>
            <SpinnerText text={"descargando..."} />
          </div>
          
        </div>
      )}
      <div className="min-w-full shadow-md  border">
        {/* Header */}
        {fetchingData && (
          <div
            className="grid text-gray-500 font-semibold p-3 border-b border-gray-300 shadow"
            style={{ gridTemplateColumns: `repeat(${headers.length}, minmax(0, 1fr))` }}
          >
          </div>
        )}
        {!fetchingData && (
          <div
            className="grid text-gray-500 font-semibold p-3 border-b border-gray-300 shadow"
            style={{ gridTemplateColumns: `repeat(${headers.length}, minmax(0, 1fr))` }}
          >
            {headers.map((headerItem, index) => (
              <div key={index} className="p-2 text-xs text-center">
                {headerItem}
              </div>
            ))}
          </div>
        )}
        {/* Body */}
        {fetchingData && (
          <div className='flex w-full mx-auto justify-center items-center my-5'>
            <Spinner />
          </div>
          
        )}
        {!fetchingData && registers.length > 0 && (
          <div>
            {registers.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className="grid px-3 py-1 hover:bg-graysens"
                style={{ gridTemplateColumns: `repeat(${headers.length}, minmax(0, 1fr))` }}
              >
                {headers.map((headerItem, colIndex) => (
                  <div key={colIndex} className="p-2 text-center">
                    {headerItem === 'ACCIONES' ? (
                      <div className='flex items-center justify-center gap-4 '>
                        {
                          row[headerItem].map((action, actionIndex) => {
                            if (action === "EDIT") {
                              return (
                              <div key={actionIndex} id={rowIndex} className='cursor-pointer' onClick={() => actions[action](registers[rowIndex])}>
                                <EditIco fill='bluesens'/>
                              </div>)
                            }
                            if (action === "DELETE") {
                              return (
                              <div key={actionIndex} id={rowIndex} className='cursor-pointer' onClick={() => actions[action](registers[rowIndex])}>
                                <TrashIco height="18px" fill='red'/>
                              </div>)
                            }
                          })
                        }
                      </div>
                      
                    ) : (
                      <div>
                        {
                          !row[headerItem] && typeof(row[headerItem]) === "object" && (
                            <>--</>
                          )
                        }
                        { typeof(row[headerItem]) !== "object" && (
                          <>
                          {row[headerItem] ?  row[headerItem] : "--"}
                          </>
                        )}
                        { typeof(row[headerItem]) === "object" && !!row[headerItem] && (
                          <DictArrayValues valueName ={headerItem} value={row[headerItem]} />
                        )}
                      </div>
                      
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
        {registers.length === 0 && !fetchingData && (
          <div className='flex items-center justify-center text-gray-700  my-5'>
            <span>No se encontraron registros</span>
          </div>
        )}
        {/* Footer */}
        {!fetchingData && registers.length > 0 && (
          <section id="footer" className='w-100 shadow-md border-t items-center flex '>
            <div className='flex justify-between py-3 w-full'>
              <div className='mx-3 text-sm  text-gray-500'>{total} total</div>
              <div className='mx-9'>
                <ComboBox
                  value={rowsNumber}
                  label={"resultados por página"}
                  options={[5,10,15,20,25,30]}
                  onChange={handleRowSelection}
                />
              </div>
              <div className='mx-3'>
                <Pagination
                  total={total}
                  currentPage={currentPage}
                  maxPaginationPages={rowsNumber}
                  onChange={handlePagination}
                />
              </div>
            </div>
          </section>
        )}
        
      </div>
    </div>
  )
});

export default GenericTable